module.exports = __webpack_public_path__ + "img/9788994475646.8c500459.jpg";